module.exports = __webpack_public_path__ + "media/images/logos/windeurope-confex2019-bec66b867bb1ca7abf4900de5b4886ad.svg";